module.exports = __webpack_public_path__ + "img/dell.f2dfeb7b.svg";